import { importProvidersFrom } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ActionReducerMap } from '@ngrx/store';
import { provideState } from '@ngrx/store';
import { sharedStateKey } from './state';
import { NavigationReducer } from './state/navigation/reducers/navigation.reducer';
import { OrganizationReducer } from './state/organization/reducers/organization.reducer';
import { OrganizationEffects } from './state/organization/effects/organization.effects';
import { AnalyticalDatasetRequestReducer } from './state/analytical-dataset-request/reducers/analytical-dataset-request.reducer';
import { AnalyticalDatasetRequestEffects } from './state/analytical-dataset-request/effects/analytical-dataset-request.effects';
import { FileReducer } from './state/files/reducers/file.reducer';
import { FileEffects } from './state/files/effects/file.effects';
import { provideEffects } from '@ngrx/effects';
import { ArchiveRequestEffects } from './state/archive-request';
import { ArchiveRequestReducer } from './state/archive-request/reducers/archive-request.reducer';
import { LoaderReducer } from './state/loader/reducers/loader.reducer';
import { ThemeReducer } from './state/theme/reducers/theme.reducer';
import { createLocalStorageSyncReducer } from './utils/local-storage-sync';

export interface SharedFeatureState {
  navigationState: ReturnType<typeof NavigationReducer>;
  organizationState: ReturnType<typeof OrganizationReducer>;
  analyticalDatasetRequestState: ReturnType<typeof AnalyticalDatasetRequestReducer>;
  fileState: ReturnType<typeof FileReducer>;
  archiveRequestState: ReturnType<typeof ArchiveRequestReducer>;
  loaderState: ReturnType<typeof LoaderReducer>;
  themeState: ReturnType<typeof ThemeReducer>;
}

const moduleReducers: ActionReducerMap<SharedFeatureState> = {
  navigationState: NavigationReducer,
  organizationState: OrganizationReducer,
  analyticalDatasetRequestState: AnalyticalDatasetRequestReducer,
  fileState: FileReducer,
  archiveRequestState: ArchiveRequestReducer,
  loaderState: LoaderReducer,
  themeState: ThemeReducer,
};

const localStorageSyncReducer = createLocalStorageSyncReducer<SharedFeatureState>([
  { navigationState: ['sideNavMenuItems'] },
  { organizationState: ['organizationList'] },
  { themeState: ['theme', 'userOverride'] },
]);

export const sharedConfig = [
  importProvidersFrom(CommonModule, RouterModule),
  provideState(sharedStateKey, moduleReducers, {
    metaReducers: [localStorageSyncReducer],
  }),
  provideEffects([OrganizationEffects, AnalyticalDatasetRequestEffects, FileEffects, ArchiveRequestEffects]),
  // Note: Services and facades with providedIn: 'root' don't need to be listed here
];
